import { ApolloQueryResult, useReactiveVar } from "@apollo/client";
import { UserQuery } from "../graphql/menu.hooks";
import { currentUser, isUserLoading } from "../graphql/state";
import { IUser } from "../types";

const _refetch: (() => Promise<ApolloQueryResult<UserQuery>>) | null = null;

const getUserDetails = (user: IUser | null) => user;

export const userService = {
  getUser: () => getUserDetails(currentUser()),
  setUser: (data: UserQuery) => {
    if (!data?.user) return;

    currentUser(data.user);
    isUserLoading(false);
  },
  refetch: async () => {
    const result = await _refetch?.();
    if (result?.data) userService.setUser(result.data);
  },
};

export const useUserService = () => {
  const user = useReactiveVar(currentUser);
  const loading = useReactiveVar(isUserLoading);
  return { user, loading };
};
